import { Injectable } from '@angular/core';

// Empower's login flow stores its DRF credential as "Token <key>" on the same origin.
const TOKEN_STORAGE_KEY = 'accessToken';

@Injectable({ providedIn: 'root' })
export class HostAuthService {
  get authorization(): string | null {
    const value = localStorage.getItem(TOKEN_STORAGE_KEY);
    return value && /^Token [A-Za-z0-9]+$/.test(value) ? value : null;
  }

}
